<template>
    <div class="curriculumVideo">
        <div class="video" id="mse"></div>
        <div class="video-sidebar flex-column">
            <div class="group time">
                <h3>课节时间</h3>
                <p v-if="!courseInfo.lessonsPattern">
                    {{ `${dayjs(lessonInfo.lessonsBeginTime * 1000).format('YYYY-MM-DD HH:mm:ss')} -
                                        ${dayjs(lessonInfo.lessonsEndTime * 1000).format('HH:mm:ss')}` }}
                </p>
                <p v-else>{{ dayjs(lessonInfo.lessonsBeginTime * 1000).format('YYYY-MM-DD') }}</p>
            </div>
            <div class="group introduction">
                <h3>课程介绍</h3>
                <p v-html="(courseInfo && courseInfo.courseExplain) || '暂无简介'"></p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Player from 'xgplayer'
import HlsJsPlyaer from 'xgplayer-hls.js';
export default {
    //import引入组件才能使用
    components: {},
    props: {},
    data() {
        return {
            videoPlayer: null,//播放器
            videoType: false,//视频类型
            videoSrc: '',//视频地址
            playStamp: '',//播放标识
            currentTime: null, //当前播放时间
            isReplay: false, // 是否重播
            totalStamp: null, //可拖拽的最大进度
            interval: undefined, //非m3u8视频计时定时器
            lessonInfo: {}, //课节信息
            courseInfo: {}, //课节所在在课程信息
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        //获取视频地址
        async getDownloadsUrl() {
            let resData = await Api.Curriculum.getLessonVideoUrl(this.$route.query.id);
            let requestUrl = `${this.getDownloadUrl}${resData.data}&type=5&markId=${this.$route.query.videoType}`
            axios({
                url: requestUrl,
                method: "get",
            }).then((res) => {
                this.videoType = res.data.data.ext === 'm3u8';
                this.videoSrc = res.data.data.url;
                setTimeout(() => {
                    if (this.videoType) {
                        this.initPlayerBym3u8()
                    } else {
                        this.initPlayerBymp4()
                    }
                }, 0)

            }).catch(function (error) {
                console.log(error);
            });
        },
        //m3u8播放器
        initPlayerBym3u8() {
            this.videoPlayer = new HlsJsPlyaer({
                width: '100%',
                height: '100%',
                el: document.querySelector('#mse'),
                url: this.videoSrc,
                error: "视频异常",
                volume: 0.6, //初始音量
                autoplay: true, //自动播放
                cors: true, //请求是否跨域
                lang: 'zh-cn',
            });
            // 注册播放事件
            this.videoPlayer.on("play", () => {
                if (this.isReplay) {
                    // 重播,不设置记忆时间但依旧计时
                    this.videoPlayer.currentTime = 0;
                    this.interval = setInterval(() => {
                        this.putCountTime()
                    }, 60 * 1000)
                } else {
                    this.getWatchStamp();
                    this.interval = setInterval(() => {
                        this.putCountTime()
                    }, 60 * 1000)
                }
            })
            // 注册暂停事件
            this.videoPlayer.on("pause", () => {
                console.log('暂停---', this.videoPlayer.currentTime)
                // this.currentTime = this.videoPlayer.currentTime;
                clearInterval(this.interval);
                this.putCountTime()
            })
            // 注册重播事件
            this.videoPlayer.on("replayBtnClick", () => {
                this.isReplay = true
            })
            // 注册seeking事件
            this.videoPlayer.on("seeking", () => {
                if (this.videoPlayer.currentTime > this.totalStamp) {
                    console.log('拖拽时间不能大于已播过的最大时间');
                    this.videoPlayer.currentTime = this.totalStamp
                }
            })
        },
        // MP4播放器
        initPlayerBymp4() {
            this.videoPlayer = new Player({
                width: '100%',
                height: '100%',
                id: 'mse',
                url: this.videoSrc,
                error: "视频异常",
                volume: 0.6, //初始音量
                autoplay: true, //自动播放
                cors: true, //请求是否跨域
                lang: 'zh-cn',
            });
            // 注册播放事件
            this.videoPlayer.on("play", () => {
                if (this.isReplay) {
                    // 重播,不设置记忆时间但依旧计时
                    this.videoPlayer.currentTime = 0;
                    this.interval = setInterval(() => {
                        this.putCountTime()
                    }, 60 * 1000)
                } else {
                    this.getWatchStamp();
                    this.interval = setInterval(() => {
                        this.putCountTime()
                    }, 60 * 1000)
                }
            })
            // 注册暂停事件
            this.videoPlayer.on("pause", () => {
                console.log('暂停---', this.videoPlayer.currentTime)
                // this.currentTime = this.videoPlayer.currentTime;
                clearInterval(this.interval);
                this.putCountTime()
            })
            // 注册重播事件
            this.videoPlayer.on("replayBtnClick", () => {
                this.isReplay = true
            })
            // 注册seeking事件
            this.videoPlayer.on("seeking", () => {
                if (this.videoPlayer.currentTime > this.totalStamp) {
                    console.log('拖拽时间不能大于已播过的最大时间');
                    this.videoPlayer.currentTime = this.totalStamp
                }
            })
        },
        // 获取本次播放标识
        async getWatchStamp() {
            let params = {
                lessonId: this.$route.query.id,
                platform: this.$route.query.videoType
            }
            let resData = await Api.Curriculum.watchStamp(params);
            console.log('获取本次播放标识', resData);
            //播放标识
            this.playStamp = resData.data.learnTarget;
            this.totalStamp = resData.data.totalProgress;
        },
        // 观看计时
        async putCountTime() {
            this.currentTime = this.videoPlayer.currentTime
            let params = {
                lessonId: this.$route.query.id,
                platform: this.$route.query.videoType,
                learnTarget: this.playStamp, //播放标识
                progress: this.currentTime, //视频播放时长
            }
            let resData = await Api.Curriculum.countTime(params);
            console.log('视频计时', resData)
            try {
                if (resData.data.code == 1000) {
                    // 暂停视频、清除定时器
                    this.videoPlayer.pause();
                }
            } catch (err) {
                console.log('code为200不处理')
            }
        },
        // 获取课节信息
        async getLessonInfo() {
            let resData = await Api.Curriculum.getAsnycLive(this.$route.query.id);
            this.lessonInfo = resData.data;
            // this.$route.meta.title = this.lessonInfo.name;
            // this.$store.commit('breadPageNameChange', this.lessonInfo.name)
            this.getCourseInfo(this.lessonInfo.courseProjectId)
        },
        //获取课程信息
        async getCourseInfo(courseId) {
            let resData = await Api.Curriculum.getCourseInfo(courseId)
            console.log(resData);
            this.courseInfo = resData.data
            this.changeBreadName(this.courseInfo.courseExplain)
        },
        changeBreadName(name) {
            // console.log('跳转视频播放labelList', this.$store.state.basics.breadList);
            this.$store.commit('breadPageNameChange', name)
            // console.log('修改后视频播放labelList', this.$store.state.basics.breadList);

        }
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.getLessonInfo();
        this.getDownloadsUrl();
    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() {
        if (this.player) {
            if (document.pictureInPictureElement) {
                document.exitPictureInPicture();
            }
            this.player.dispose();
        }
    },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style lang="less" scoped>
@import "./less/curriculumVideo.less";
</style>